// Need to use the React-specific entry point to import createApi
import { baseApi } from "./baseApi";
import { getToken } from "./localStorageService";

// using CSRF token from Local Storage

// Define a service using a base URL and expected endpoints
export const cuisineTypeApi = baseApi.injectEndpoints({

  credentials: "include",
  endpoints: (builder) => ({
    addCuisineType: builder.mutation({
      query: (data) => {
        return {
          url: "cuisine",
          method: "POST",
          body: data,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      // invalidatesTags: ['User'],
    }),
    updateCuisineType: builder.mutation({
      query: ({data, slug}) => {
        return {
          url: `cuisine/${slug}`,
          method: "PATCH",
          body: data,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      // invalidatesTags: ['User'],
    }),
    deleteCuisineType: builder.mutation({
      query: (slug) => {
        return {
          url: `cuisine/${slug}`,
          method: "DELETE",
          // body: user,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      // invalidatesTags: ['User'],
    }),
    getAllCuisineType: builder.query({
      query: ({ limit, skip }) => {
        return {
          url: `cuisine?limit=${limit}&skip=${skip}`, // todo:
          method: "GET",
          // headers: {
          //   "Content-type": "application/json; charset=UTF-8",
          // },
        };
      },
      keepUnusedDataFor: 0,
      refetchOnFocus: true,
      // providesTags: ['User'],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useAddCuisineTypeMutation,
  useUpdateCuisineTypeMutation,
  useDeleteCuisineTypeMutation,
  useGetAllCuisineTypeQuery,
} = cuisineTypeApi;
